/* Citana Organics — Field Guide theme */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    const fmt = (window.Citana && Citana.money) || '${{amount}}';
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, (cents / 100).toFixed(2));
  }

  /* ---------- Mobile drawer ---------- */
  const drawer = $('#menu-drawer');
  $$('[data-menu-open]').forEach(b => b.addEventListener('click', () => { drawer.setAttribute('open', ''); document.body.style.overflow = 'hidden'; $('[data-menu-close]', drawer)?.focus(); }));
  $$('[data-menu-close]').forEach(b => b.addEventListener('click', () => { drawer.removeAttribute('open'); document.body.style.overflow = ''; }));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer?.hasAttribute('open')) { drawer.removeAttribute('open'); document.body.style.overflow = ''; } });

  /* ---------- Reveal on scroll ---------- */
  const io = new IntersectionObserver(entries => entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
  $$('[data-reveal]').forEach(el => io.observe(el));

  /* ---------- Drifting spores ---------- */
  $$('canvas.spores').forEach(cv => {
    if (reduced) return;
    const ctx = cv.getContext('2d');
    let w, h, dots = [];
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    function size() {
      const r = cv.getBoundingClientRect(); w = r.width; h = r.height;
      cv.width = w * dpr; cv.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      dots = Array.from({ length: Math.round(w * h / 9000) }, () => ({ x: Math.random() * w, y: Math.random() * h, r: Math.random() * 1.8 + .4, s: Math.random() * .35 + .08, d: Math.random() * Math.PI * 2, a: Math.random() * .6 + .2 }));
    }
    size(); window.addEventListener('resize', size);
    let visible = true;
    new IntersectionObserver(e => { visible = e[0].isIntersecting; }).observe(cv);
    (function tick(t) {
      if (visible) {
        ctx.clearRect(0, 0, w, h);
        for (const p of dots) {
          p.y -= p.s; p.x += Math.sin(t / 2400 + p.d) * .25;
          if (p.y < -5) { p.y = h + 5; p.x = Math.random() * w; }
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(240,196,110,${p.a})`; ctx.fill();
        }
      }
      requestAnimationFrame(tick);
    })(0);
  });

  /* ---------- Spore to harvest scroll story ---------- */
  $$('[data-story]').forEach(story => {
    const steps = $$('.story__step', story);
    const counter = $('.story__counter span', story);
    const media = $$('.story__media > *', story);
    const path = $('.story__thread path', story);
    let len = 0;
    if (path) { len = path.getTotalLength(); path.style.strokeDasharray = len; path.style.strokeDashoffset = len; }
    function setActive(i) {
      steps.forEach((s, k) => s.classList.toggle('is-active', k === i));
      media.forEach((m, k) => m.classList.toggle('is-active', k === i));
      if (counter) counter.textContent = String(i + 1).padStart(2, '0');
    }
    const so = new IntersectionObserver(entries => entries.forEach(en => { if (en.isIntersecting) setActive(steps.indexOf(en.target)); }), { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach(s => so.observe(s));
    if (path) {
      const list = $('.story__steps', story);
      const onScroll = () => {
        const r = list.getBoundingClientRect();
        const p = Math.min(1, Math.max(0, (window.innerHeight * .5 - r.top) / r.height));
        path.style.strokeDashoffset = len * (1 - p);
      };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    setActive(0);
  });

  /* ---------- Postcode → harvest run ---------- */
  $$('[data-postcode]').forEach(wrap => {
    let runs = {};
    try { runs = JSON.parse($('script[type="application/json"]', wrap).textContent); } catch (e) {}
    const form = $('form', wrap), input = $('input', wrap), out = $('.postcode__result', wrap);
    form.addEventListener('submit', e => {
      e.preventDefault();
      const pc = (input.value || '').trim();
      const hit = runs[pc];
      if (!/^\d{4}$/.test(pc)) { out.innerHTML = 'Pop in a four-digit postcode.'; return; }
      out.innerHTML = hit
        ? `<strong>${hit.day} harvest run</strong>We deliver to ${hit.towns}. Order by the weekly cut-off and it arrives on ${hit.day}.`
        : `<strong>Not on a run yet</strong>Collect from one of our pick-up points or the Saturday market, or <a href="/pages/contact?enquiry=delivery">ask us about your area</a>.`;
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-qty]'); if (!b) return;
    const input = b.parentElement.querySelector('input');
    const v = Math.max(parseInt(input.min || 0, 10), (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qty, 10));
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product: variants, gallery, selling plans ---------- */
  $$('[data-product]').forEach(root => {
    let data; try { data = JSON.parse($('script[data-product-json]', root).textContent); } catch (e) { return; }
    const form = $('form[action*="/cart/add"]', root);
    const idInput = $('input[name="id"]', form);
    const priceEl = $('[data-price]', root), compareEl = $('[data-compare]', root);
    const btn = $('[data-add]', root);
    const planInput = $('input[name="selling_plan"]', form);
    function current() {
      if (!$$('.option', root).length) return data.variants.find(v => String(v.id) === String(idInput.value)) || data.variants[0];
      const chosen = $$('.option', root).map(f => ($('input:checked', f) || {}).value);
      return data.variants.find(v => v.options.every((o, i) => o === chosen[i]));
    }
    function planPrice(v) {
      const mode = ($('input[name="purchase_type"]:checked', root) || {}).value;
      if (mode !== 'plan' || !planInput) return null;
      const alloc = (v.selling_plan_allocations || []).find(a => String(a.selling_plan_id) === String(planInput.value));
      return alloc ? alloc.price : null;
    }
    function update() {
      const v = current();
      // availability marking
      $$('.option', root).forEach((f, idx) => {
        $$('input', f).forEach(inp => {
          const others = $$('.option', root).map(g => ($('input:checked', g) || {}).value);
          others[idx] = inp.value;
          const match = data.variants.find(x => x.options.every((o, i) => o === others[i]));
          inp.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      const pp = planPrice(v);
      priceEl.textContent = money(pp != null ? pp : v.price);
      if (compareEl) { const c = pp != null ? v.price : v.compare_at_price; compareEl.textContent = c && c > (pp != null ? pp : v.price) ? money(c) : ''; }
      btn.disabled = !v.available;
      btn.textContent = v.available ? (btn.dataset.label || 'Add to basket') : (btn.dataset.soldout || 'Sold out');
      if (v.featured_media_id) showMedia(v.featured_media_id);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }
    function showMedia(id) {
      const t = $(`[data-media-thumb="${id}"]`, root); if (t) t.click();
    }
    $$('.option input', root).forEach(i => i.addEventListener('change', update));
    $$('input[name="purchase_type"]', root).forEach(r => r.addEventListener('change', () => {
      if (!planInput || !r.checked) return;
      const sel = $('[data-plan-select]', root);
      planInput.disabled = r.value !== 'plan';
      if (r.value === 'plan' && sel) planInput.value = sel.value;
      update();
    }));
    const planSel = $('[data-plan-select]', root);
    if (planSel) planSel.addEventListener('change', () => { planInput.value = planSel.value; const r = $('input[value="plan"]', root); if (r) { r.checked = true; planInput.disabled = false; } update(); });
    // gallery
    const main = $('[data-main-img]', root);
    $$('[data-media-thumb]', root).forEach(t => t.addEventListener('click', () => {
      $$('[data-media-thumb]', root).forEach(x => x.setAttribute('aria-current', 'false'));
      t.setAttribute('aria-current', 'true');
      main.src = t.dataset.src; main.srcset = t.dataset.srcset || ''; main.alt = t.dataset.alt || '';
    }));
    update();
  });

  /* ---------- AJAX add to cart ---------- */
  const toast = $('#toast'); let toastTimer;
  function showToast(html) {
    toast.innerHTML = html; toast.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { toast.hidden = true; }, 5000);
  }
  async function refreshCount() {
    try { const c = await (await fetch('/cart.js')).json(); $$('[data-cart-count]').forEach(el => { el.textContent = c.item_count; el.dataset.count = c.item_count; }); } catch (e) {}
  }
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!form.matches('form[data-ajax-cart]')) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]'); const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      const res = await fetch(window.Citana.routes.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || 'Could not add that item.');
      await refreshCount();
      showToast(`<span>${json.product_title} added to your basket</span><a href="${window.Citana.routes.cart}">View basket</a>`);
    } catch (err) {
      showToast(`<span>${err.message}</span>`);
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = label; }
    }
  });

  /* ---------- Cart: harvest run required before checkout ---------- */
  $$('form[data-cart-form]').forEach(f => {
    f.addEventListener('submit', e => {
      const needs = f.querySelector('[data-run-required]');
      if (e.submitter && e.submitter.name === 'checkout' && needs && !f.querySelector('input[name="attributes[Harvest run]"]:checked')) {
        e.preventDefault();
        const box = f.querySelector('.run-choice'); box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        showToast('<span>Choose a harvest run or pick-up point first.</span>');
      }
    });
    $$('input[data-autosubmit]', f).forEach(i => i.addEventListener('change', () => {
      clearTimeout(i._t); i._t = setTimeout(() => f.requestSubmit ? f.requestSubmit() : f.submit(), 450);
    }));
  });

  /* ---------- Contact: preselect enquiry type from ?enquiry= ---------- */
  const enq = new URLSearchParams(location.search).get('enquiry');
  if (enq) { const s = $('select[data-enquiry]'); if (s) { const o = $$('option', s).find(o => o.dataset.key === enq); if (o) s.value = o.value; } }
})();
